/* eslint-disable import/no-named-default */

import { default as AddMemberSearch } from './AddMemberSearch';
import { default as ADGroup } from './ADGroup';
import { default as BusinessApp } from './BusinessApp';
import { default as Sector } from './Sector';
import { default as Environments } from './Environments';
import { default as GroupOwner } from './GroupOwner';
import { default as IsADGroupCreate } from './IsADGroupCreate';
import { default as AppShortName } from './AppShortName';
import { default as ADGroupType } from './ADGroupType';
import { default as ApplicationName } from './ApplicationName';
import { default as ADGroupMembers } from '../sections/ADGroupMembers';
import { default as ADGroupMembersRemoval } from '../sections/ad-group-membership-removal/ADGroupMembersRemoval';
import { default as ApplicationService } from './ApplicationService';
import { default as SelectMemberBtn } from './SelectMemberBtn';
import { default as GroupType } from './GroupType';
import { default as LDAPGroup } from './LDAPGroup';
import { default as ProjectName } from './ProjectName';
import { default as ServiceAccount } from './ServiceAccount';
import { default as ADGroupOwner } from './ADOwner';
import { default as MultipleADGroup } from './multiple/MultipleADGroup';
import { default as MultipleSelectMemberBtn } from './multiple/MutlipleSelectMemberBtn';
import { default as AppOwnerSearch } from './AppOwnerSearch';
import { default as TypeOfRequest } from './TypeOfRequest';
import { default as ModifyRequestType } from './ModifyRequestType';
import { default as DomainType } from './DomainType';
import * as ResourceSection from './ResourceSection';

const Forms = {
    ADGroup,
    AddMemberSearch,
    BusinessApp,
    Sector,
    Environments,
    GroupOwner,
    IsADGroupCreate,
    AppShortName,
    ADGroupType,
    ApplicationName,
    ADGroupMembers,
    ADGroupMembersRemoval,
    ApplicationService,
    SelectMemberBtn,
    GroupType,
    LDAPGroup,
    ProjectName,
    ServiceAccount,
    ADGroupOwner,
    MultipleADGroup,
    MultipleSelectMemberBtn,
    AppOwnerSearch,
    TypeOfRequest,
    ModifyRequestType,
    DomainType,
    Resource: ResourceSection,
};

export default Forms;
